<template>
	<div>
		<TheAlert />
		<div class="accordion" id="coreQuestionsAccordion">
			<div
				class="accordion-item"
				v-for="(question, index) in coreQuestionsDataset"
				:key="'question-' + index"
			>
				<h2 class="accordion-header" :id="'heading' + index">
					<span class="row g-0 question-container">
						<span
							class="col-1 d-flex align-items-center justify-content-center question-no"
						>
							Q{{ index + 1 }}
						</span>

						<span
							v-if="!question.localizations['EN'].description.includes('${')"
							class="col-7 question-text d-flex text-opacity pe-3  align-items-center"
						>
							{{ question.localizations["EN"].description }}
						</span>

						<span
							v-else
							class="col-7 question-text d-flex pe-3  align-items-center"
						>
							<span class="text-opacity me-2"
								>{{ question.localizations["EN"].description.split("${")[0] }}
							</span>
							<placeholder
								:question="question.localizations['EN'].description"
								:question-index="index"
							></placeholder>

							<span class="text-opacity ms-2"
								>{{ question.localizations["EN"].description.split("}")[1] }}
							</span>
						</span>

						<span
							class=" col-4 d-flex justify-content-end view-answer-btn pe-3"
						>
							<button
								class="accordion-button collapsed ps-0 py-4 justify-content-end"
								type="button"
								data-bs-toggle="collapse"
								:data-bs-target="'#collapse' + index"
								aria-expanded="true"
								:aria-controls="'collapse' + index"
							>
								<span> View Answers </span>
							</button>
						</span>
					</span>
				</h2>
				<div
					:id="'collapse' + index"
					class="accordion-collapse collapse"
					:aria-labelledby="'heading' + index"
					data-bs-parent="#coreQuestionsAccordion"
				>
					<div class="accordion-body">
						<div class="offset-1 col">
							<ul class="list-unstyled px-4">
								<li
									class="mb-4 answers"
									v-for="(option, index) of question.choices"
									:key="'option-' + index"
								>
									{{ option.localizations["EN"].localizedChoice }}
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import TheAlert from "./the-alert.vue";
import Placeholder from "./placeholder";
import { mapGetters } from "vuex";

export default {
	name: "CoreQuestions",
	components: { TheAlert, Placeholder },
	computed: {
		...mapGetters("surveyJourney", {
			coreQuestionsDataset: "coreQuestionsDataset",
		}),
	},
	methods: {},
};
</script>

<style lang="scss" scoped>
.question-container {
	@extend %font-16-regular;
	&:hover {
		.view-answer-btn span {
			opacity: 1;
		}
	}
}

.text-opacity {
	opacity: 0.57;
}

.view-answer-btn span {
	opacity: 0;
	transition: $transition-400ms;
}
</style>
